import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaHeart, FaStar, FaRegHeart, FaRegStar } from 'react-icons/fa';
import { useApp } from '../App';
import './Gallery.css';

function Gallery() {
  const [tab, setTab] = useState('action');
  const [items, setItems] = useState([]);
  const [recipes, setRecipes] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [myRatings, setMyRatings] = useState({});
  const [emailPrompt, setEmailPrompt] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const { userEmail, setUserEmail } = useApp();

  const loadRecipes = () => {
    axios.get('https://api.hospifylink.com/api/recipes').then(r => {
      if (Array.isArray(r.data)) setRecipes(r.data);
    }).catch(() => {});
    
    if (userEmail) {
      axios.get(`/api/wishlist?email=${userEmail}`)
        .then(r => {
          if (Array.isArray(r.data)) setWishlist(r.data.map(w => w.recipe_id));
        })
        .catch(() => {});
      axios.get('https://api.hospifylink.com/api/recipes').then(r => {
        if (!Array.isArray(r.data)) return;
        const ratings = {};
        r.data.forEach(rec => {
          axios.get(`/api/recipes/${rec.id}/rating?email=${userEmail}`)
            .then(res => {
              if (res.data) ratings[rec.id] = res.data.rating;
              setMyRatings({ ...ratings });
            })
            .catch(() => {});
        });
      }).catch(() => {});
    }
  };

  useEffect(() => {
    axios.get(`/api/gallery?type=${tab}`).then(r => {
      if (Array.isArray(r.data)) setItems(r.data);
    }).catch(() => {});
  }, [tab]);

  useEffect(() => { loadRecipes(); }, [userEmail]);

  const requireEmail = (action) => {
    if (userEmail) action();
    else { setPendingAction(() => action); setEmailPrompt(true); }
  };

  const submitEmail = (e) => {
    e.preventDefault();
    const em = e.target.email.value.trim();
    if (!em) return;
    setUserEmail(em);
    setEmailPrompt(false);
    setTimeout(() => pendingAction && pendingAction(), 100);
  };

  const toggleWish = (id) => requireEmail(() => {
    axios.post('/api/wishlist/toggle', { user_email: userEmail, recipe_id: id })
      .then(r => {
        setWishlist(prev => r.data.added ? [...prev, id] : prev.filter(x => x !== id));
      });
  });

  const rate = (id, value) => requireEmail(() => {
    axios.post(`/api/recipes/${id}/rate`, { user_email: userEmail, rating: value })
      .then(() => {
        setMyRatings({ ...myRatings, [id]: value });
        loadRecipes();
      });
  });

  const safeItems = Array.isArray(items) ? items : [];
  const safeRecipes = Array.isArray(recipes) ? recipes : [];

  return (
    <div className="gallery-root">
      <div className="gallery-hero fade-in">
        <h1>Gallery</h1>
        <p>Our professionals in action &amp; our finest culinary creations</p>
      </div>

      <div className="gallery-tabs">
        <button
          className={tab === 'action' ? 'gallery-tab-active' : ''}
          onClick={() => setTab('action')}
        >
          Professionals in Action
        </button>
        <button
          className={tab === 'recipe' ? 'gallery-tab-active' : ''}
          onClick={() => setTab('recipe')}
        >
          Recipes
        </button>
      </div>

      {tab === 'action' ? (
        <div className="gallery-grid">
          {safeItems.map((it, i) => (
            <div
              key={it.id}
              className="gallery-item fade-up"
              style={{ animationDelay: `${i * 0.05}s` }}
            >
              <img src={it.image} alt={it.title} />
              <div className="gallery-item-overlay"><h4>{it.title}</h4></div>
            </div>
          ))}
          {safeItems.length === 0 && <p className="gallery-empty">No action images yet.</p>}
        </div>
      ) : (
        <div className="gallery-grid">
          {safeRecipes.map((r, i) => (
            <div
              key={r.id}
              className="gallery-recipe fade-up"
              style={{ animationDelay: `${i * 0.05}s` }}
            >
              <div className="gallery-recipe-img-wrap">
                <img src={r.image} alt={r.title} />
                <button
                  className={`gallery-wish ${wishlist.includes(r.id) ? 'gallery-wish-active' : ''}`}
                  onClick={() => toggleWish(r.id)}
                  title={wishlist.includes(r.id) ? 'Remove from wishlist' : 'Add to wishlist'}
                >
                  {wishlist.includes(r.id) ? <FaHeart /> : <FaRegHeart />}
                </button>
              </div>
              <div className="gallery-recipe-body">
                <h4>{r.title}</h4>
                <p>{r.description?.slice(0, 60)}...</p>
                <div className="gallery-rating">
                  {[1, 2, 3, 4, 5].map(s => (
                    <button key={s} onClick={() => rate(r.id, s)} className="gallery-star">
                      {s <= (myRatings[r.id] || Math.round(r.avg_rating))
                        ? <FaStar />
                        : <FaRegStar />}
                    </button>
                  ))}
                  <span>({Number(r.avg_rating || 0).toFixed(1)})</span>
                </div>
              </div>
            </div>
          ))}
          {safeRecipes.length === 0 && <p className="gallery-empty">No recipes yet.</p>}
        </div>
      )}

      {emailPrompt && (
        <div className="gallery-modal" onClick={() => setEmailPrompt(false)}>
          <form
            className="gallery-modal-box"
            onClick={e => e.stopPropagation()}
            onSubmit={submitEmail}
          >
            <h3>Enter your email to continue</h3>
            <p>We use this only to save your wishlist &amp; ratings.</p>
            <input
              name="email"
              type="email"
              placeholder="you@example.com"
              required
              autoFocus
            />
            <button type="submit" className="lca-btn-primary">Continue</button>
          </form>
        </div>
      )}
    </div>
  );
}

export default Gallery;
